import SelectComparablePropertySkeleton from './select-comparable-property-skeleton'

export default SelectComparablePropertySkeleton
